import _ from 'lodash'

export default (turns) => (
  _.tail(_.reverse(_.reject(turns, { type: 'trade', traded: null })))
)
